import { ComponentType, LoadingButton } from '@gcl/react-core';
import { useSyncTraining } from './admin.queries';

export const AdminPageSyncTrainingRecordButton = () => {
  const { isLoading, isSuccess, isError, mutate } = useSyncTraining();
  return (
    <div className="gcl-gems-admin-sync-training-record-header-container">
      <LoadingButton
        type={ComponentType.Primary}
        onClick={() => {
          mutate();
        }}
        isLoading={isLoading}
        isSuccess={isSuccess}
        isError={isError}
      >
        Sync Training Record Daily
      </LoadingButton>
    </div>
  );
};
